import { session } from 'utilities/storage'
import { sanitizeFilter } from 'state/utilities'
import { pick, size } from 'utilities/object'

// Filter
export const getFilter = (props = {}, initial = false) => {
    let filter = props.filter ?? null

    if(initial && (!filter || props.filterOptions?.merge) && props.filterOptions?.key) {
        const memoryFilter = session.get(props.filterOptions.key)

        if(!filter || !props.filterOptions?.merge) {
            filter = memoryFilter
        }

        if(!!filter && props.filterOptions?.merge) {
            filter = {
                ...memoryFilter,
                ...filter
            }
        }
    }

    filter = !!filter ?
        sanitizeFilter(filter) :
        null

    return {
        filter,
        filterOptions: props.filterOptions ?? null,
        filterApplied: !!size(filter ?? {})
    }
}

// Paging
export const getPaging = (props = {}) => ({
    paging: {
        limit: 25,
        ...(props.paging ?? null)
    }
})

export const getInitialClientState = ({ queryOptions, ...props }) => ({
    ...(!!queryOptions ? { queryOptions } : null),
    ...pick(props, 'path', 'adaptParams', 'adaptItems'),
    ...getFilter(props, true),
    ...getPaging(props),
    signal: Date.now()
})